import superMeta from '../_CATEGORY/metaCategoryNode.mjs'

export default {
    ...superMeta,
    name: '需求项',
    type: 'ISRF_REQ',
}
